import React from 'react';
import './HomeStudentLife.css';

// Importing images
import image1 from '../../../assets/Hall 3.jpg'; 
import image2 from '../../../assets/sports.jpg';
import image3 from '../../../assets/Library.png'; 
import image4 from '../../../assets/yoga.jpeg';

function HomeStudentLife() {
  
  // Data array
  const lifeEvents = [
    {
      id: 1,
      image: image1,
      title: "Interactive Halls"
    },
    {
      id: 2,
      image: image2,
      title: "Sports & Recreation"
    },
    {
      id: 3,
      image: image3,
      title: "Library"
    },
    {
      id: 4,
      image: image4,
      title: "Yoga & Wellness"
    },
  ];

  return (
    <section className="hsl-section">
      <div className="hsl-container">
        
        {/* --- Header --- */}
        <div className="hsl-header">
          <span className="hsl-tag">Experience SK College</span>
          <h2 className="hsl-title">Life on Campus</h2>
          <div className="hsl-title-underline"></div>
          <p className="hsl-subtitle">
            Beyond textbooks and lectures, discover a world of creativity, wellness, and community.
          </p>
        </div>

        {/* --- Mosaic Grid --- */}
        <div className="hsl-grid">
          {lifeEvents.map((item) => (
            <div key={item.id} className="hsl-card">
              
              <div className="hsl-image-wrapper">
                <img src={item.image} alt={item.title} className="hsl-img" />
              </div>

              <div className="hsl-content-overlay">
                <div className="hsl-content-inner">
                  <h3 className="hsl-card-title">{item.title}</h3>
                </div>
                
                <div className="hsl-icon-wrapper">
                  <div className="hsl-arrow-icon">➜</div>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default HomeStudentLife;